/** Layer 1: fetch the localized enum catalog from backend — no React/TanStack imports. */
import { apiClient } from "@/shared/lib/axios";
import { API } from "@/shared/lib/apiPaths";

/**
 * One choice in a dropdown list. `label` is already localized by the backend
 * (resolved from the request's `Accept-Language`). `amazonSupported` is only
 * present on `language` items — a display hint, never an enforcement gate.
 *
 * Backend renders responses through `CamelCaseJSONRenderer`, so the wire field
 * is `amazonSupported` (snake `amazon_supported` is camelized in transit).
 */
export interface EnumItem {
  value: string;
  label: string;
  amazonSupported?: boolean;
}

/**
 * The full enum catalog keyed by list name. Keys arrive camelCased
 * (`contributorRole`, `ageGroup`, `interiorColour`, …) because of the backend
 * camel-case renderer; `useEnumList` accepts the backend snake_case name and
 * camelizes it before lookup.
 */
export type EnumCatalog = Record<string, EnumItem[]>;

/** GET /api/v1/enums — every dropdown list the frontend renders, localized. */
export async function getEnums(): Promise<EnumCatalog> {
  const { data } = await apiClient.get<EnumCatalog>(`${API}/enums`);
  return data;
}
